import { Box } from "@chakra-ui/react";
import React from "react";

import { Table, TableColumn } from "../../../../components";
import { SettingSwitch } from "./SettingSwitch";
import { SettingSwitchWithConfirmDialogue } from "./SettingSwitchWithConfirmDialogue";

export interface DisplayData {
  autoJoinAllNewPositions: boolean;
  atsOptInAllNewPositions: boolean;
}

interface RecordingSettingsAllFutureOrgProps {
  displayData: Array<DisplayData>;
  updatePositionsRecordingSettings: (
    autoJoinInterview: boolean,
    atsOptInInterview: boolean
  ) => Promise<any>;
  showOptIn: boolean;
}

const RecordingSettingsAllFutureOrg: React.FC<
  RecordingSettingsAllFutureOrgProps
> = ({ displayData, updatePositionsRecordingSettings, showOptIn = false }) => {
  const columns: TableColumn[] = [
    {
      Header: "Future Positions",
      accessor: "name",
      Cell: () => <Box>All Future Positions</Box>,
    },
    {
      Header: "Auto Join All New Positions",
      accessor: "autoJoinAllNewPositions",
      Cell: (displayData) => {
        return (
          <SettingSwitch
            onToggle={(newValue) =>
              updatePositionsRecordingSettings(
                newValue,
                displayData.atsOptInAllNewPositions
              )
            }
            isChecked={displayData.autoJoinAllNewPositions}
          >
            {displayData.autoJoinAllNewPositions
              ? "Auto-join enabled"
              : "Auto-join disabled"}
          </SettingSwitch>
        );
      },
    },
  ];

  if (showOptIn) {
    const optInColumn: TableColumn = {
      Header: "Opt In All New Positions",
      accessor: "atsOptInAllNewPositions",
      Cell: (displayData) => {
        return (
          <SettingSwitchWithConfirmDialogue
            onToggle={(newValue) =>
              updatePositionsRecordingSettings(
                displayData.autoJoinAllNewPositions,
                newValue
              )
            }
            shouldConfirm={!displayData.atsOptInAllNewPositions}
            isChecked={displayData.atsOptInAllNewPositions}
            headerText="Are you sure you want to enable opt-in consent for all positions?"
            headerBody={
              <>
                Enabling <strong>Opt In All New Positions</strong> will
                immediately apply opt-in rules to all active candidates. Any
                candidate not currently assigned to an opt-in position will be
                automatically marked as Opted Out, which may disrupt scheduling
                and generate a large volume of opt-out notification emails. This
                change may be difficult to reverse.
              </>
            }
            confirmButtonText="Proceed Anyways"
          >
            {displayData.atsOptInAllNewPositions
              ? "Opt-in consent"
              : "Opt-out consent"}
          </SettingSwitchWithConfirmDialogue>
        );
      },
    };
    columns.splice(columns.length - 1, 0, optInColumn);
  }

  return <Table w="1200px" mb={3} columns={columns} data={displayData} />;
};

export default RecordingSettingsAllFutureOrg;
